import clsx from 'clsx';
import type { ReactNode } from 'react';
import { style } from './product-card-fields.module.css';

interface Props {
  enabledTransition?: boolean;
  children: ReactNode;
}

export function ProductCardFields(props: Props) {

  const {
    enabledTransition,
    children
  } = props;

  return (
    <div className={clsx(style.container, enabledTransition && style.transition)}>
      {children}
    </div>
  );
}
